import { MotionValue } from "framer-motion";
import { memo, useState } from "react";
import {
  getDurationFromSliderIndex,
  getDurationSliderRange,
} from "./Brush.utils";
import { formatDuration } from "date-fns";

import { Slider } from "@/components/ui/slider";

interface BrushControlDurationSliderProps {
  cursorDurationMotionValue: MotionValue<number>;
  onDurationChange: (duration: number) => void;
}

const BrushControlDurationSlider = memo(function BrushControlDurationSlider({
  cursorDurationMotionValue,
  onDurationChange,
}: BrushControlDurationSliderProps) {
  const [duration, setDuration] = useState(0);

  return (
    <div
      // width: "stretch",
      // display: "flex",
      // alignItems: "center",
      // height: "48px",
      // border: 1,
      // borderColor: "divider",
      // borderRadius: "sm",
      // backgroundColor: "var(--muted)",
      // mt: 1,
      // justifyContent: "center",
      className=""
    >
      <Slider
        value={[duration]} // Convert duration to linear index
        onValueChange={([value]) => {
          const newDuration = getDurationFromSliderIndex(value); // Convert index back to duration
          onDurationChange(newDuration);
          setDuration(value);
        }}
        min={getDurationSliderRange().min}
        max={getDurationSliderRange().max}
        step={0.2}
        className="w-150"
      />
    </div>
  );
});

export { BrushControlDurationSlider };
